document.addEventListener('DOMContentLoaded', () => {
  let isSliderTransition = false;

  function updateThumbsSlider(container) {
    if (!container) return;
    const thumbs = container.querySelector('.js-product-slider-thumbs');
    if (!thumbs) return;

    const currentTranslate = parseInt(thumbs.dataset.translate || 0);
    thumbs.style.transform = `translateX(-${currentTranslate}px)`;
  }

  function showSelectedSlide(id) {
    if (isSliderTransition) {
      return;
    }

    const thumbsList = document.querySelectorAll(
      '.js-product-slider-thumbs picture'
    );
    thumbsList.forEach(thumb => {
      const slideId = thumb.dataset.slide;
      thumb.classList.toggle('active-slide', slideId === id);
    });

    const nextSlide = document.getElementById('slide' + id);
    const currentSlide = document.querySelector(
      '.js-product-slider-items picture:not([style*="display: none"])'
    );
    if (!nextSlide || nextSlide === currentSlide) {
      return;
    }

    isSliderTransition = true;

    const currentHeight = currentSlide.querySelector('img').offsetHeight;

    // Fade out current slide
    currentSlide.style.opacity = '1';
    currentSlide.style.transition = 'opacity 200ms';
    currentSlide.style.opacity = '0';

    nextSlide.querySelector('img').style.height = `${currentHeight}px`;

    setTimeout(() => {
      currentSlide.style.display = 'none';

      // Fade in next slide
      nextSlide.style.display = '';
      nextSlide.style.opacity = '0';
      nextSlide.style.transition = 'opacity 200ms';

      // Need a small delay to ensure display change is processed
      requestAnimationFrame(() => {
        nextSlide.style.opacity = '1';

        setTimeout(() => {
          isSliderTransition = false;
        }, 200);
      });
    }, 200);

    // Auto-scroll thumbs to selected one
    const activeThumb = Array.from(thumbsList).find(t => t.dataset.slide === id);
    if (activeThumb) {
      const container = activeThumb.closest('.js-product-slider-thumbs-wrapper');
      if (container) {
        const thumbs = container.querySelector('.js-product-slider-thumbs');
        const thumbsContainer = container.querySelector('.js-product-slider-thumbs-container');
        const index = Array.from(thumbs.querySelectorAll('picture')).indexOf(
          activeThumb
        );
        const itemWidth = 75 + 16;
        const totalCount = thumbs.querySelectorAll('picture').length;
        const containerWidth = thumbsContainer.offsetWidth;
        const totalWidth = totalCount * itemWidth - 16; // exclude last gap

        let translate = index * itemWidth + 75 / 2 - containerWidth / 2;
        const maxTranslate = Math.max(0, totalWidth - containerWidth);

        if (translate < 0) translate = 0;
        if (translate > maxTranslate) translate = maxTranslate;

        thumbs.dataset.translate = translate;
        updateThumbsSlider(container);
      }
    }
  }

  document.querySelectorAll('.js-product-slider-thumbs-wrapper').forEach(container => {
    updateThumbsSlider(container);
  });

  $(document).on('change', '.js-load-slider', function () {
    const path = this.dataset.slider;
    if (!path) {
      return;
    }

    fetch(path, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => response.text())
      .then(result => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = result;
        document.querySelector('.js-product-slider').innerHTML =
          tempDiv.innerHTML;

        document.querySelectorAll('.js-product-slider-thumbs-wrapper').forEach(container => {
          updateThumbsSlider(container);
        });
      });
  });

  $(document).on('click', '.js-button-slider', function () {
    const path = this.dataset.slider
    if (!path) {
      return
    }

    fetch(path, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.text())
      .then((result) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = result
        document.querySelector('.js-product-slider').innerHTML =
          tempDiv.innerHTML

        document
          .querySelectorAll('.js-product-slider-thumbs-wrapper')
          .forEach((container) => {
            updateThumbsSlider(container)
          })
      })
  })

  $(document).on('change', 'select', function () {
    const id = this.options[this.selectedIndex].dataset.slider
    if (id) {
      showSelectedSlide(id)
    }
  })

  $(document).on('click', '.js-product-slider-thumbs picture', function () {
    const slideId = this.dataset.slide

    showSelectedSlide(slideId)
  })
});
